import { z } from 'zod';
export const ContentDraftType = z.enum(['post', 'poll', 'fundraiser', 'event']);
export const ContentDraftData = z.record(z.string(), z.unknown());
export const CreateContentDraftInput = z.object({
    type: ContentDraftType,
    data: ContentDraftData,
});
export const UpdateContentDraftInput = CreateContentDraftInput.extend({
    version: z.number().int().positive(),
});
export const ContentDraftView = CreateContentDraftInput.extend({
    id: z.string(),
    version: z.number().int().positive(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const DeleteContentDraftResult = z.object({ id: z.string(), deleted: z.literal(true) });
//# sourceMappingURL=content-draft.js.map